// Functionality for grantees index page.
// Controls the filter functionality for the grantees list.

(function () {
  const queryParamTopic = new URLSearchParams(window.location.search).get(
    "topic"
  );

  // Filter controls
  const topicSelect = document.querySelector(
    '[data-filter-control="education-topic"]'
  );
  const speakerSelect = document.querySelector(
    '[data-filter-control="education-speaker"]'
  );
  const resetButton = document.querySelector("[data-filter-reset]");

  // Grantees list
  const articlesWrapper = document.querySelector(
    '[data-js="articles_wrapper"]'
  );
  const articles = [
    ...document.querySelectorAll('[data-filter="article_item"]'),
  ];

  // If the query param topic is set, select that value and run the filter
  if (queryParamTopic) {
    topicSelect.value = queryParamTopic;
    filterArticles();
  }

  doArticlesFilter();

  function filterArticles() {
    // update the query param if the user changes the filter
    if (topicSelect.value) {
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?topic=${topicSelect.value}`
      );
    } else {
      window.history.replaceState({}, "", window.location.pathname);
    }

    if ("startViewTransition" in document) {
      document.startViewTransition(() => {
        doArticlesFilter();
      });
    } else {
      doArticlesFilter();
    }
  }

  function doArticlesFilter() {
    const selectedTopic = topicSelect.value;
    const selectedSpeaker = speakerSelect.value;

    articlesWrapper.classList.add("no-results");

    articles.forEach((article) => {
      const topics = article.dataset.topics;
      const speaker = article.dataset.speaker;
      if (
        (selectedTopic === "" || topics.includes(selectedTopic)) &&
        (selectedSpeaker === "" || speaker === selectedSpeaker)
      ) {
        articlesWrapper.classList.remove("no-results");
        article.classList.remove("excluded");
      } else {
        article.classList.add("excluded");
      }
    });

    // remove the hidden class from the wrapper (this stops ugly flashes of unfiltered content)
    articlesWrapper.classList.remove("opacity-0");
  }

  function resetFilters() {
    topicSelect.value = "";
    speakerSelect.value = "";
    articles.forEach((article) => article.classList.remove("excluded"));
    articlesWrapper.classList.remove("no-results");
  }

  topicSelect.addEventListener("change", filterArticles);
  speakerSelect.addEventListener("change", filterArticles);
  resetButton.addEventListener("click", resetFilters);
})();
